export default "__VITE_ASSET__fc8bc7c3__"